import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";
import { initTheme } from "./theme";
import { primeLanguage } from "./i18n";

// Before render, not inside a component: reading the stored choice during the first
// render paints light and then flips, which is the flash every themed site is
// judged by.
initTheme();
primeLanguage();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
